module.exports = {
      id: "authorwhite-usage",
      viewBox: "0 0 30.127 24.506",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#authorwhite",
      toString: function () {
        return this.url;
      }
    }